<template>
  <div class="page-content">
    <div class="card">
      <div class="card-header">
        <h1 class="card-header-title">{{ content.title }}</h1>
        <p class="card-header-description">{{ content.description }}</p>
      </div>
      <ItemList :items="localItems" :action="updateActiveItems" />
      <CustomButton
        variation="primary"
        :onClick="() => action(formatListToSubmit)"
        :disabled="!multiSelectIsValid()"
        >Continue</CustomButton
      >
    </div>
  </div>
</template>
<script>
import ItemList from "@/components/ItemList.vue";
import CustomButton from "@/components/CustomButton.vue";

export default {
  data() {
    return {
      localItems: this.items,
    };
  },
  props: {
    action: {
      type: Function,
      required: true,
    },
    content: {
      type: Object,
      required: true,
      default: () => ({
        title: String,
        description: String,
        image: String,
      }),
    },
    items: {
      type: Array,
      required: true,
      default: () => [
        {
          id: String,
          label: String,
          to: String,
          icon: String,
          text: String,
          description: String,
          isActive: Boolean,
          target_field: String,
          value: [String, Boolean, Array],
        },
      ],
    },
  },
  components: {
    ItemList,
    CustomButton,
  },
  computed: {
    formatListToSubmit() {
      return this.localItems
        .filter((item) => item.isActive)
        .map((item) => item.value);
    },
  },
  methods: {
    multiSelectIsValid() {
      return this.localItems.find((item) => item.isActive);
    },
    updateActiveItems(selectedItem) {
      const result = this.localItems.map((el) =>
        el.id == selectedItem.id ? { ...el, isActive: !el.isActive } : el
      );

      this.localItems = result;
    },
  },
};
</script>
